import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withKeys as _withKeys, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/images/ball.svg'
import _imports_1 from '../campaigns/assets/images/plus.svg'
import _imports_2 from '../campaigns/assets/images/default-big.png'


const _withScopeId = n => (_pushScopeId("data-v-09f8a022"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "badge p-d-flex p-ai-center",
  ref: "target"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "ball",
  src: _imports_0
}, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "badge-red"
}
const _hoisted_4 = ["onMouseover", "onClick"]
const _hoisted_5 = { style: {"display":"flex","gap":"12px"} }
const _hoisted_6 = {
  key: 0,
  style: {"width":"50px","height":"50px","object-fit":"cover","border-radius":"4px"},
  src: _imports_2
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "p-d-flex p-flex-column color" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "p-mt-1 color" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "notifications",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => {$setup.showNotificationsItems = !$setup.showNotificationsItems;}, ["stop"]))
    }, [
      _hoisted_2,
      ($setup.countNewNotifications > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    ($setup.showNotificationsItems)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["notifications-items", { 'show-more': $setup.isGetMore, 'notifications-wrapper-dark': $setup.isNewDesignEnabled }]),
          onScroll: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.windowOnscroll && $setup.windowOnscroll(...args))),
          ref: "notificationBlock"
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["title-notifications", { 'show-more-title': $setup.isGetMore, 'title-dark': $setup.isNewDesignEnabled }])
          }, [
            _createTextVNode(" Notifications "),
            ($setup.isGetMore)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "plus",
                  src: _imports_1,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.showNotificationsItems = false))
                }))
              : _createCommentVNode("", true)
          ], 2),
          ($setup.isGetMore)
            ? (_openBlock(), _createBlock(_component_InputText, {
                key: 0,
                type: "text",
                modelValue: $setup.searchValue,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.searchValue) = $event)),
                placeholder: "Search for notification",
                class: _normalizeClass(["search-input", { 'search-input-dark': $setup.isNewDesignEnabled }]),
                onInput: $setup.searchNotifications,
                onKeydown: _withKeys($setup.searchNotifications, ["enter"])
              }, null, 8, ["modelValue", "onInput", "onKeydown", "class"]))
            : _createCommentVNode("", true),
          ($setup.isGetMore)
            ? (_openBlock(), _createBlock(_component_Dropdown, {
                key: 1,
                modelValue: $setup.selectMostRecent,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.selectMostRecent) = $event)),
                options: $setup.rangeDate,
                optionLabel: "title",
                optionValue: "value",
                onChange: $setup.changeFilter,
                placeholder: "Most recent",
                class: _normalizeClass(["select-most-recent", { 'select-most-recent-dark': $setup.isNewDesignEnabled }])
              }, null, 8, ["modelValue", "options", "onChange", "class"]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.notificationsFromUser, (notify, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["notifications-item", { 'notifications-item-dark': $setup.isNewDesignEnabled }]),
              style: _normalizeStyle(notify?.status === 'new' ? 'font-weight: bold;' : ''),
              key: `${index}_nof`,
              onMouseover: ($event: any) => (notify?.status === 'new' ? $setup.changeStatusNotify(notify, index) : null),
              onClick: ($event: any) => ($setup.handleAction(notify))
            }, [
              _createElementVNode("div", _hoisted_5, [
                (!notify?.brandId?.photo || notify?.campaignId?.photo || !notify?.from?.profile?.photo)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      style: {"width":"50px","height":"50px"},
                      src: !$props.isBrand ? notify?.brandId?.photo : notify?.from?.profile?.photo
                    }, null, 8, _hoisted_7)),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", {
                    innerHTML: notify?.message
                  }, null, 8, _hoisted_9),
                  _createElementVNode("span", _hoisted_10, _toDisplayString($setup.timeAgo(notify?.createdAt)), 1)
                ])
              ])
            ], 46, _hoisted_4))
          }), 128)),
          (!$setup.isGetMore)
            ? (_openBlock(), _createElementBlock("span", {
                key: 2,
                class: _normalizeClass(["p-d-flex p-justify-center color-red", { 'see-more-dark': $setup.isNewDesignEnabled }]),
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => {$setup.getMoreNotifications(); $setup.isGetMore = true}, ["stop"]))
              }, " See more notifications ", 2))
            : _createCommentVNode("", true)
        ], 34))
      : _createCommentVNode("", true)
  ], 512))
}